module.exports = __webpack_public_path__ + "static/larway-logo-f361485f8ccdd2688b1c55dc9ed7f207.png";